const Loader =()=>{
   return(
    <div className="container" style={{display:"flex",justifyContent:"space-between"}}>
    <div className="time">
    </div>
    <div className="time">
    </div>
    <div className="time">
    </div>
    </div>
   )
}

export default Loader;